jQuery(document).ready(function ($) {
  $('.like-button, .dislike-button').on('click', function () {
    var postId = $(this).closest('.like-bar').data('id');
    var url = $(this).closest('.like-bar').data('url');
    var action = $(this).hasClass('like-button') ? 'like' : 'dislike';

    $.post(url, {
      action: action,
      post_id: postId
    }, function (response) {
      if (response.success) {
        $('#likes-count-' + postId).text(response.data.likes);
        $('#dislikes-count-' + postId).text(response.data.dislikes);
      } else {
        alert(response.data); // Show the error message
      }
    });
  });
});
